import Icon from 'components/atoms/Icon/Icon';
import React, { useContext } from 'react';
import { ShippingBoxCtn } from './ShippingFree.styled';
import MetroPostCodes from './metroPostcodes.json';
import AuthContext from 'context/AuthProvider';
import { get } from 'lodash';
import CartContext from 'context/CartProvider';

const ShippingFree = ({ totalAmount, setHideSWidget = undefined }) => {
  const auth = useContext(AuthContext);
  const cartCtx = useContext(CartContext);

  const { object, isLoggedIn } = get(auth, 'state', {});
  const cart = get(cartCtx, 'state.cart', {});

  const getFreeShip = 99;
  const isFreeShip = totalAmount >= getFreeShip;
  let toGetFreeShipAmount = 101;
  if (!isFreeShip) toGetFreeShipAmount = Number(getFreeShip - totalAmount).toFixed(2);
  const freePercent = Number(100 - (toGetFreeShipAmount / getFreeShip) * 100).toFixed(0);
  const onMetroArea = object?.addresses.some(address =>
    MetroPostCodes.includes(Number(address.postal_code))
  );
  
  const haveMedication =  cart?.productInfo ? Object.values(cart?.productInfo)?.some(item =>
    item.custom_fields?.find(field => field.name === 'Product Type' && field.value === 'Medication')
  ) : true;
  if (!isLoggedIn || !onMetroArea || haveMedication) {
    if (setHideSWidget !== undefined) setHideSWidget(true);
    return <></>;
  }
  return (
    <ShippingBoxCtn $percent={isFreeShip ? 100 : freePercent}>
      <div>
        <div className="title">
          {isFreeShip
            ? 'Your order ships for free*'
            : `You're $${toGetFreeShipAmount} away from free delivery`}
        </div>
        <div className="description">
          *Spend over $99 on non-prescription medication items (metro areas only)
        </div>
        <div className="status">
          <div className="line">
            <div className="percent"></div>
          </div>
          <div className="boxIcon">
            <Icon symbol="shipping-box"></Icon>
          </div>
        </div>
      </div>
    </ShippingBoxCtn>
  );
};

export default ShippingFree;
